import {Type} from '@angular/core';

import {BaseFilter} from './base/base.filter';

export class GeoCountyFilter extends BaseFilter {
    public description: string;
    public geoDistrictId: string;

    public constructor() {
        super();
    }

    protected getType(): Type<BaseFilter> {
        return GeoCountyFilter;
    }
}
